import { Outlet } from 'react-router-dom';
import AppShell from './components/Layout/AppShell.jsx';
import { HelpProvider } from './help/HelpProvider.jsx';
import SinaAssistant from './components/SinaAssistant/SinaAssistant.jsx';

export default function AppLayout() {
  return (
    <HelpProvider>
      <AppShell>
        <Outlet />
      </AppShell>
      <SinaAssistant />
    </HelpProvider>
  );
}
